import {LicenseTypes} from './constants'

export const canCreateDevice = (license, existing) => {
  if (!license) {
    return false
  }

  switch (license.type) {
    case LicenseTypes.Unlimited:
      return true

    case LicenseTypes.Limited:
      return license.licenses > existing
    default:
      return false
  }
}

export const canCreateRemote = canCreateDevice
